import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import { router } from './router.js'
import { Toaster } from './components/ui/index.js'
import { AdminI18nProvider } from './lib/i18n.js'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 1000 * 30, // 30s
      refetchOnWindowFocus: true,
    },
  },
})

// PWA: instalar o service worker (tela de cozinha/garçom em tablet/TV)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js')
  })
}

const root = document.getElementById('root')!
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AdminI18nProvider>
        <RouterProvider router={router} />
        <Toaster />
      </AdminI18nProvider>
    </QueryClientProvider>
  </StrictMode>,
)
